// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SettingsManagePurchase_wrapper__1si2a","statusCell":"SettingsManagePurchase_statusCell__1Xg3_"};